import { render, staticRenderFns } from "./_Form.vue?vue&type=template&id=3bf0ef72&"
import script from "./_Form.vue?vue&type=script&lang=js&"
export * from "./_Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports